import { createAsyncThunk } from "@reduxjs/toolkit";
import { authSilceName } from ".";
import { resetCompanyStateAction } from "../app/companySlice";

export const logoutAction = createAsyncThunk(`${authSilceName}/logout`, async (_, thunkAPI) => {
  thunkAPI.dispatch(resetCompanyStateAction());
});
